import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import IntrestandShorlistedService from "../../services/intrestandshortlisted.service";

/* ================= THUNKS ================= */

export const sendInterest = createAsyncThunk(
  "interest/send",
  async (data, thunkAPI) => {
    try {
      const res = await IntrestandShorlistedService.sendInterest(data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

export const getReceivedInterests = createAsyncThunk(
  "interest/received",
  async (params, thunkAPI) => {
    try {
      const res = await IntrestandShorlistedService.getReceivedInterests(params);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

export const getSentInterests = createAsyncThunk(
  "interest/sent",
  async (params, thunkAPI) => {
    try {
      const res = await IntrestandShorlistedService.getSentInterests(params);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);
export const getShortlistData = createAsyncThunk(
  "shortlist/getShortlistData",
  async (params, thunkAPI) => {
    try {
      const res = await IntrestandShorlistedService.getShortlistData(params);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

export const respondToInterest = createAsyncThunk(
  "interest/respond",
  async (data, thunkAPI) => {
    try {
      const res = await IntrestandShorlistedService.respondToInterest(data);
      return { ...res.data, request: data }; // keep id
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

export const shortlistUser = createAsyncThunk(
  "shortlist/add",
  async (data, thunkAPI) => {
    try {
      const res = await IntrestandShorlistedService.shortlistUser(data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

/* ================= INITIAL STATE ================= */

const initialState = {
  loading: false,
  actionLoading: false, // for accept/decline/send
  error: null,

  receivedInterests: [],
  sentInterests: [],
  shortlistedData:[],
  shortlist: [],

  updateSuccess: false,
};

/* ================= SLICE ================= */

const slice = createSlice({
  name: "interestShortlist",
  initialState,
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder

      /* ---------- SEND INTEREST ---------- */
      .addCase(sendInterest.pending, (state) => {
        state.actionLoading = true;
      })
      .addCase(sendInterest.fulfilled, (state) => {
        state.actionLoading = false;
        state.updateSuccess = true;
      })
      .addCase(sendInterest.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
      })

      /* ---------- GET RECEIVED ---------- */
      .addCase(getReceivedInterests.pending, (state) => {
        state.loading = true;
      })
      .addCase(getReceivedInterests.fulfilled, (state, action) => {
        state.loading = false;
        state.receivedInterests = action.payload?.data || [];
      })
      .addCase(getReceivedInterests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //-----------------  GET DATA ------------ 

      .addCase(getShortlistData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getShortlistData.fulfilled, (state, action) => {
        state.loading = false;
        state.shortlistedData = action.payload?.data || [];
      })
      .addCase(getShortlistData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- GET SENT ---------- */
      .addCase(getSentInterests.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSentInterests.fulfilled, (state, action) => {
        state.loading = false;
        state.sentInterests = action.payload?.data || [];
      })
      .addCase(getSentInterests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- RESPOND (ACCEPT/REJECT) ---------- */
      .addCase(respondToInterest.pending, (state) => {
        state.actionLoading = true;
      })
      .addCase(respondToInterest.fulfilled, (state, action) => {
        state.actionLoading = false;

        const { interestId, action: act } = action.payload.request;

        const item = state.receivedInterests.find(
          (i) => i.interestId === interestId
        );

        if (item) {
          item.status = act === "accept" ? "accepted" : "rejected";
        }
      })
      .addCase(respondToInterest.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
      })

      /* ---------- SHORTLIST ---------- */
      .addCase(shortlistUser.pending, (state) => {
        state.actionLoading = true;
      })
      .addCase(shortlistUser.fulfilled, (state, action) => {
        state.actionLoading = false;
        state.updateSuccess = true;

        const item = action.payload?.data;
        if (item) {
          state.shortlist.unshift(item);
        }
      })
      .addCase(shortlistUser.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateStatus } = slice.actions;
export default slice.reducer;